import { observer, inject } from 'mobx-react'
import { ApplicationStoreKey, IApplicationStore } from '../../liveStores';
import { TicketDetailTicketByNumberBaseContainer, TicketDetailPublicTicketBaseContainer, TicketDetailMyTicketBaseContainer, TicketDetailLegacyPublicTicketBaseContainer } from './ticketDetailContainer';
import { pushToEventDetail, redirectToPrematchEventDetailFromLive } from '../../liveRouting';

@inject(ApplicationStoreKey)
@observer
export class TicketDetailMyTicketLiveContainer extends TicketDetailMyTicketBaseContainer {

    canShowLinkToAddToChat: boolean = this.props.applicationStore.canShowAddPublicLinkToTicketToChat;

    addPublicLinkToChat(hash: string, isLegacy: boolean): void {
        (this.props.applicationStore as IApplicationStore).chat.addTicketPublicLink(hash, isLegacy);
    }

    goToPrematchEvent(id: number): void {
        redirectToPrematchEventDetailFromLive({ eventKey: id.toString() });
    }

    goToLiveEvent(id: number): void {
        pushToEventDetail(id);
    }

    componentWillMount() {
        (this.props.applicationStore as IApplicationStore).setCanShowLeftColumn(true);
        super.componentWillMount();
    }
}

@inject(ApplicationStoreKey)
@observer
export class TicketDetailPublicTicketLiveContainer extends TicketDetailPublicTicketBaseContainer {

    canShowLinkToAddToChat: boolean = this.props.applicationStore.canShowAddPublicLinkToTicketToChat;

    addPublicLinkToChat(hash: string): void {
        (this.props.applicationStore as IApplicationStore).chat.addTicketPublicLink(hash, false);
    }

    goToPrematchEvent(id: number): void {
        redirectToPrematchEventDetailFromLive({ eventKey: id.toString() });
    }

    goToLiveEvent(id: number): void {
        pushToEventDetail(id);
    }

    componentWillMount() {
        (this.props.applicationStore as IApplicationStore).setCanShowLeftColumn(true);
        super.componentWillMount();
    }
}

@inject(ApplicationStoreKey)
@observer
export class TicketDetailLegacyPublicTicketLiveContainer extends TicketDetailLegacyPublicTicketBaseContainer {

    canShowLinkToAddToChat: boolean = this.props.applicationStore.canShowAddPublicLinkToTicketToChat;

    addPublicLinkToChat(hash: string): void {
        (this.props.applicationStore as IApplicationStore).chat.addTicketPublicLink(hash, true);
    }

    goToPrematchEvent(id: number): void {
        redirectToPrematchEventDetailFromLive({ eventKey: id.toString() });
    }

    goToLiveEvent(id: number): void {
        pushToEventDetail(id);
    }

    componentWillMount() {
        (this.props.applicationStore as IApplicationStore).setCanShowLeftColumn(true);
        super.componentWillMount();
    }
}

@inject(ApplicationStoreKey)
@observer
export class TicketDetailTicketByNumberLiveContainer extends TicketDetailTicketByNumberBaseContainer {

    canShowLinkToAddToChat: boolean = this.props.applicationStore.canShowAddPublicLinkToTicketToChat;

    addPublicLinkToChat(hash: string, isLegacy: boolean): void {
        (this.props.applicationStore as IApplicationStore).chat.addTicketPublicLink(hash, isLegacy);
    }

    goToPrematchEvent(id: number): void {
        redirectToPrematchEventDetailFromLive({ eventKey: id.toString() });
    }

    goToLiveEvent(id: number): void {
        pushToEventDetail(id);
    }

    componentWillMount() {
        (this.props.applicationStore as IApplicationStore).setCanShowLeftColumn(true);
        super.componentWillMount();
    }
}